import { gsap, ScrollTrigger } from "../layout"

// custom library
import Choices from 'choices.js'
import axios from 'axios'
import Cleave from 'cleave.js'

function choicesJs() {
    const sortElement = document.querySelector('#activity-sort')

    if (sortElement) {
        const choices = new Choices(sortElement, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }

    const area = document.querySelector('#area')

    if (area) {
        const choices = new Choices(area, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }
}

function customRangeSlider() {
    // https://medium.com/@predragdavidovic10/native-dual-range-slider-html-css-javascript-91e778134816

    const fromSlider = document.querySelector('#fromSlider');
    const toSlider = document.querySelector('#toSlider');
    const fromInput = document.querySelector('#fromInput');
    const toInput = document.querySelector('#toInput');

    if (!fromSlider || !toSlider || !fromInput || !toInput) return; // Exit if any element is not found

    function initCleave() {
        new Cleave(fromInput, {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
        });
    
        new Cleave(toInput, {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
        });
    }

    initCleave()

    if (fromSlider) {
        function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
            const min = parseInt(fromInput.min)
            console.log(fromInput);
            const [from, to] = getParsed(fromInput, toInput);
            fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
            if (from < min) {
                fromInput.value = min
                fromSlider.value = min
            } else if (from > to) {
                fromSlider.value = to;
                fromInput.value = to;
            } else {
                fromInput.value = from;
                fromSlider.value = from;
            }

            initCleave()
        }
            
        function controlToInput(toSlider, fromInput, toInput, controlSlider) {
            const max = parseInt(toInput.max)
            const [from, to] = getParsed(fromInput, toInput);
            fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
            setToggleAccessible(toInput);
            console.log(from);
            console.log(to);
            if (to > max) {
                toInput.value = max
                toSlider.value = max
            } else if (from <= to) {
                toSlider.value = to;
                toInput.value = to;
            } else {
                toInput.value = from;
                toSlider.value = from;
            }

            initCleave()
        }
        
        function controlFromSlider(fromSlider, toSlider, fromInput) {
            const [from, to] = getParsed(fromSlider, toSlider);
            fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
            if (from > to) {
                fromSlider.value = to;
                fromInput.value = to;
            } else {
                fromInput.value = from;
            }

            initCleave()
        }
        
        function controlToSlider(fromSlider, toSlider, toInput) {
            const [from, to] = getParsed(fromSlider, toSlider);
            fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
            setToggleAccessible(toSlider);
            if (from <= to) {
                toSlider.value = to;
                toInput.value = to;
            } else {
                toInput.value = from;
                toSlider.value = from;
            }

            initCleave()
        }
        
        function getParsed(currentFrom, currentTo) {
            const from = stringCurrencyToNumber(currentFrom.value);
            const to = stringCurrencyToNumber(currentTo.value);
            return [from, to];
        }

        function stringCurrencyToNumber(numberString) {
            return parseInt(numberString.replace(/,/g, ''), 10)
        }
        
        function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
            const rangeDistance = to.max-to.min;
            const fromPosition = stringCurrencyToNumber(from.value) - to.min;
            const toPosition = stringCurrencyToNumber(to.value) - to.min;
            controlSlider.style.background = `linear-gradient(
                to right,
                ${sliderColor} 0%,
                ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
                #FDB716 ${((fromPosition)/(rangeDistance))*100}%,
                #FDB716 ${(toPosition)/(rangeDistance)*100}%, 
                ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
                ${sliderColor} 100%)`;
        }
        
        function setToggleAccessible(currentTarget) {
            const toSlider = document.querySelector('#toSlider');
            if (Number(currentTarget.value) <= 0 ) {
                toSlider.style.zIndex = 2;
            } else {
                toSlider.style.zIndex = 0;
            }
        }
        
        fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
        setToggleAccessible(toSlider);
        
        fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
        toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
        fromInput.onblur = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
        toInput.onblur = () => controlToInput(toSlider, fromInput, toInput, toSlider);
    }
}

function removeFilter() {
    const buttonFilters = document.querySelectorAll('.list__filter-link')

    if (buttonFilters) {
        buttonFilters.forEach(bf => {
            bf.addEventListener('click', (e) => {
                e.preventDefault()
                // Get the current URL
                const currentUrl = window.location.href;

                const filter = bf.dataset.filter;

                const paramKeys = filter.split(',')

                // Create a URL object
                const url = new URL(currentUrl);

                // Loop through each parameter key and remove it from the URL search params
                paramKeys.forEach(function(paramKey) {
                    url.searchParams.delete(paramKey.trim());
                });
    
                // Redirect to the modified URL
                window.location.href = url.toString();
            })
        });
    }
}

function emptyValueFormFilter() {
    // https://stackoverflow.com/questions/8029532/how-to-prevent-submitting-the-html-forms-input-field-value-if-it-empty/64029534#64029534
    // remove empty value from url when submitting form
    const form = document.querySelector('.filter-form');

    if (form) {
        form.addEventListener('formdata', function(event) {
            const formData = event.formData;
            for (let [name, value] of Array.from(formData.entries())) {
                if (value === '') formData.delete(name);
            }
        });
    }
}

// FUNCTION LOAD MORE
function loadMoreAjax() {
    const button = document.querySelector('.list__loadmore')
    const loadingBtn = document.querySelector('.list__loading')
    const buttonWrapper = document.querySelector('.list__button')
    let posts_list = document.querySelector('.list__row')

    if (!button) return; // Exit function if button is not found

    if (posts_list.dataset.page == posts_list.dataset.max) {
        // button.parentNode.removeChild(button)
        buttonWrapper.classList.add('d-none')
    }

    button.addEventListener('click', (e) => {
        e.preventDefault()
        let current_page = posts_list.dataset.page

        let params = new URLSearchParams({
            action: 'load_more_activity',
            current_page: current_page,
            post_type: 'product',
            posts_per_page: 9,
            type: defaultParams.type,
            location: defaultParams.location,
            privateVilla: defaultParams.privateVilla,
            handPicked: defaultParams.handPicked,
            minPrice: defaultParams.minPrice,
            maxPrice: defaultParams.maxPrice,
            event: defaultParams.event,
            sort: defaultParams.sort,
            template_parts: 'template-parts/activity-list',
        })

        button.classList.add('d-none')
        loadingBtn.classList.add('d-inline-block')

        axios.post('/wp-admin/admin-ajax.php', params)
        .then(res => {

            posts_list.insertAdjacentHTML('beforeend', res.data.data)

            posts_list.dataset.page++ // increment dataset

            button.innerHTML = '<div class="themeBtn__inner"><span>Load More</span></div>'
            
            button.classList.remove('d-none')

            loadingBtn.classList.remove('d-inline-block')
            
            ScrollTrigger.refresh() // refresh scroll

            // check if dataset page equal to dataset max
            // if equal, remove load more button
            if (posts_list.dataset.page == posts_list.dataset.max) {
                // button.parentNode.removeChild(button)
                buttonWrapper.classList.add('d-none')
            }
        })
    })
}

function sortingActivity() {
    const formElement = document.querySelector('#sorting-form')

    const selectElement = document.querySelector('#activity-sort')

    if (selectElement) {
        selectElement.addEventListener('change', (item) => {
            formElement.submit()
        })
    }
}

function setActiveNavbar() {
    const params = new URLSearchParams(window.location.search).get('location')

    if (!params) return

    const menu = document.querySelector('.navbar-location-parent .menu-link[data-custom-tab="#tab-' + params + '"]').parentElement

    menu.classList.add('active')
}

document.addEventListener('DOMContentLoaded', () => {
    choicesJs()
    customRangeSlider()
    removeFilter()
    emptyValueFormFilter()
    loadMoreAjax()
    sortingActivity()
    setActiveNavbar()
})